module.exports = __webpack_public_path__ + "rs.f1db11a25fb8d156ff6d.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/rs.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/rs.svg
// module chunks = styles